import type { ISearchExchangeSearchOption } from '@rdlabo/odss-mobile-hono/src/api/functions/search-exchange/api';
import type { ISearchTransactionSearchOption } from '@rdlabo/odss-mobile-hono/src/api/functions/search-transaction/api';
import { format, subDays } from 'date-fns';

export type * from '../../../shared/src/interfaces';

export const defaultSearchOption = (): ISearchExchangeSearchOption => {
  return {
    exchangeId: null,
    startDate: format(subDays(new Date(), 1), 'yyyy/MM/dd'),
    endDate: format(new Date(), 'yyyy/MM/dd'),
    exType: null,
    companyId: null,
    userName: null,
    registerId: null,
    isCashCustomer: false,
  };
};

export const defaultTransactionSearchOption = (): ISearchTransactionSearchOption => {
  return {
    slipId: null,
    startDate: format(subDays(new Date(), 1), 'yyyy/MM/dd'),
    endDate: format(new Date(), 'yyyy/MM/dd'),
    skuName: '',
    skuId: null,
    subjectName: '',
    customerName: '',
    companyId: null,
    slipType: '1,7',
  };
};

export const SlipType = {
  1: '売上',
  2: '仕入',
  3: '移動',
  // 4: '移動(to)',
  5: '棚卸',
  6: '見積',
  7: '返品',
  8: '仕入返品',
  // 9: '仕入発注',
  12: '多目的',
};

export const SlipTypeAll = {
  1: '売上',
  2: '仕入',
  3: '移動',
  4: '移動(to)',
  5: '棚卸',
  6: '見積',
  7: '返品',
  8: '仕入返品',
  9: '仕入発注',
  12: '多目的',
};

export const SearchSlipType = {
  '1,7': '売上・返品',
  '2,8': '仕入・仕入返品',
  3: '移動',
  4: '移動(to)',
  5: '棚卸',
  6: '見積',
  7: '返品',
  1: '売上',
  2: '仕入',
  8: '仕入返品',
  9: '仕入発注',
  12: '多目的',
};

/** print.pr_sliptype（1〜3=売上系 / 4〜5=見積系） */
export const PrintSlipType = {
  1: '出荷伝票',
  2: '納品書',
  3: '納品書兼領収書',
  4: '見積書定価あり',
  5: '見積書定価なし',
};

export const SearchSlipDefault = {
  slipNo: null,
  startDate: null,
  endDate: null,
  slipType: '1,7',
  taskType: null,
  information: null,
  companyId: null,
  subjectId: null,
  reqId: null,
  onlyNoTransaction: false,
  createdTaskUser: null,
};

export const companySettings = {
  close: {
    5: '5日',
    10: '10日',
    15: '15日',
    20: '20日',
    25: '25日',
    30: '末日',
    99: '都度',
  },
  site: {
    1: '当月',
    2: '翌月',
    3: '翌々月',
    99: '都度',
  },
  paymentDate: {
    5: '5日',
    10: '10日',
    15: '15日',
    20: '20日',
    25: '25日',
    30: '末日',
    99: '都度',
  },
  calc: {
    1: '四捨五入',
    2: '切捨',
    3: '切上',
  },
  type: {
    1: '得意先',
    2: '仕入先',
  },
  rule: {
    1: '振込',
    2: '集金',
    3: '持参',
    4: '現金',
    5: 'クレジットカード',
  },
};

export const subjectType = {
  1: '居宅',
  2: '箱物',
  3: '修理',
  4: 'その他',
};

export const defaultAddition = () => ({
  companyName: '',
  employeeName: '',
  repName: '',
  subjectName: '',
});
